<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item"><router-link :to="booksPath">小説管理</router-link></li>
                <li class="breadcrumb-item"><router-link :to="`/mypage/book/${$route.params.book_id}/sections/`">本文一覧</router-link></li>
                <li class="breadcrumb-item">ノート編集</li>
            </ol>
        </nav>
        <legend class="text-center my-2">
            <h3 v-if="book.id" class="mincho">{{book.title}}</h3>
        </legend>
        <div class="container">
            <notes ref="notes"
                :book_id="$route.params.book_id"
                :focus="true"
                :book="book"
                @searchNote="searchNote"></notes>
        </div>
        <search-note :book_id="$route.params.book_id" @found="foundNote($event)" @replace="replaceNote($event)"></search-note>
    </div>
</template>

<style scoped lang="scss">
@media screen and (max-width: 640px) {
    .container, .container-fluid {
        padding: 0;
    }
    .breadcrumb {
        margin: 0;
    }
}
</style>

<script>
import notes from "./notes";
import searchNote from "./searchNote";
export default {
    components: {
        notes,
        searchNote,
    },
    data() {
        return {
            book: {},
        }
    },
    methods: {
        load() {
            // 本
            axios.get("/mypage/book/get", {params: {id: this.$route.params.book_id}}).then(res => {
                this.book = res.data;
            }).catch(err => {
                alert.err(err.response);
            });
        },
        searchNote() {
            $("#search-note").modal();
        },
        foundNote(result) {
            this.$refs.notes.found(result);
        },
        replaceNote(words) {
            this.$refs.notes.replaceKeyword(words);
        }
    },
    computed: {
        booksPath() {
            if (this.book) {
                if (this.book.is_hidden === 3) {
                    return "/mypage/books/pending";
                } else if (this.book?.property?.is_finished) {
                    return "/mypage/books/finished";
                }
            }
            return "/mypage/books";
        },
    },
    mounted() {
        this.load();
    }
}
</script>